import React, { useEffect, useState } from "react";
import API from "../services/api";

const Profile = () => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchAdminProfile = async () => {
    try {
      setLoading(true);
      const res = await API.get("/profile");

      if (res.data.success) {
        setAdmin(res.data.admin);
      } else {
        setError("Failed to fetch admin profile");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminProfile();
  }, []);

  if (loading) {
    return <div style={styles.loading}>Loading secure profile...</div>;
  }

  if (error) {
    return <div style={styles.error}>{error}</div>;
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* PROFILE HEADER / AVATAR */}
        <div style={styles.profileHeader}>
          <div style={styles.avatar}>
            {admin?.name?.charAt(0).toUpperCase() || "A"}
          </div>
          <h2 style={styles.adminName}>{admin?.name || "Admin User"}</h2>
          <span style={styles.roleBadge}>{admin?.role || "Administrator"}</span>
        </div>

        <div style={styles.infoSection}>
          {/* EMAIL */}
          <div style={styles.infoRow}>
            <span style={styles.label}>Email Address</span>
            <span style={styles.value}>{admin?.email}</span>
          </div>

          {/* STATUS */}
          <div style={styles.infoRow}>
            <span style={styles.label}>Account Status</span>
            <span>
              {admin?.isBlocked ? (
                <span style={styles.statusBlocked}>● Blocked</span>
              ) : (
                <span style={styles.statusActive}>● Active</span>
              )}
            </span>
          </div>

          {/* JOINED DATE */}
          <div style={styles.infoRow}>
            <span style={styles.label}>Member Since</span>
            <span style={styles.value}>
              {new Date(admin?.createdAt).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </span>
          </div>
        </div>

        {/* FOOTER ACTION */}
        {/*<div style={styles.cardFooter}>
          <button style={styles.editButton} onClick={() => alert("Settings coming soon!")}>
            Account Settings
          </button>
        </div>*/}
      </div>
    </div>
  );
};

export default Profile;

/* ================= STYLES ================= */

const styles = {
  page: {
    padding: "40px 20px",
    background: "#f5f7fb",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },

  card: {
    background: "#fff",
    borderRadius: "20px",
    width: "100%",
    maxWidth: "450px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
    overflow: "hidden",
    height: "fit-content",
  },

  profileHeader: {
    background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
    padding: "40px 20px",
    textAlign: "center",
    color: "#fff",
  },

  avatar: {
    width: "80px",
    height: "80px",
    background: "rgba(255,255,255,0.2)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "32px",
    fontWeight: "bold",
    margin: "0 auto 15px",
    border: "3px solid rgba(255,255,255,0.3)",
    backdropFilter: "blur(5px)",
  },

  adminName: {
    margin: "0 0 5px 0",
    fontSize: "22px",
    letterSpacing: "-0.5px",
  },

  roleBadge: {
    fontSize: "12px",
    background: "#3b82f6",
    padding: "4px 12px",
    borderRadius: "12px",
    textTransform: "uppercase",
    fontWeight: "bold",
    letterSpacing: "1px",
  },

  infoSection: {
    padding: "30px",
  },

  infoRow: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "20px",
    borderBottom: "1px solid #f1f5f9",
    paddingBottom: "12px",
  },

  label: {
    fontSize: "12px",
    color: "#64748b",
    textTransform: "uppercase",
    fontWeight: "600",
    marginBottom: "4px",
  },

  value: {
    fontSize: "15px",
    color: "#1e293b",
    fontWeight: "500",
  },

  statusActive: {
    color: "#10b981",
    fontSize: "14px",
    fontWeight: "bold",
  },

  statusBlocked: {
    color: "#ef4444",
    fontSize: "14px",
    fontWeight: "bold",
  },

  cardFooter: {
    padding: "0 30px 30px",
  },

  editButton: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
    background: "#fff",
    color: "#1e293b",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
    fontSize: "14px",
  },

  loading: {
    textAlign: "center",
    padding: "50px",
    fontSize: "18px",
    color: "#1e293b",
  },

  error: {
    color: "#ef4444",
    textAlign: "center",
    padding: "20px",
    background: "#fee2e2",
    margin: "40px auto",
    borderRadius: "12px",
    maxWidth: "400px",
  },
};